import { render, staticRenderFns } from "./UserMessageDialog.vue?vue&type=template&id=6331ec24&"
import script from "./UserMessageDialog.vue?vue&type=script&lang=js&"
export * from "./UserMessageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6331ec24')) {
      api.createRecord('6331ec24', component.options)
    } else {
      api.reload('6331ec24', component.options)
    }
    module.hot.accept("./UserMessageDialog.vue?vue&type=template&id=6331ec24&", function () {
      api.rerender('6331ec24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserMessageDialog.vue"
export default component.exports